module.exports = __webpack_public_path__ + "static/media/ace-express-freight.63cc6910.jpg";